export default __webpack_public_path__ + "static/media/fatsun.7661da64.png";